module.exports = __webpack_public_path__ + "static/media/mmcireland.7f9c279e.png";